import { render } from "./FilterComponent.vue?vue&type=template&id=2c7b4fd8"
import script from "./FilterComponent.vue?vue&type=script&lang=js"
export * from "./FilterComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Nordlux.Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__